import { type LoaderFunctionArgs, redirect } from 'react-router';

const trailingSlashRegex = /^(.+?)\/+(?=\?|$)/;

export const globalLoader = ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);

  if (url.pathname.match(trailingSlashRegex)) {
    url.pathname = url.pathname.replace(trailingSlashRegex, '$1');
    return redirect(url.toString(), 301);
  }

  return null;
};
